import type { ReactNode } from 'react';

export const symbol_download_done: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m380-422 357-357q9-9 21-8.5t21 9.5q9 9 9 21t-9 21L401-358q-9 9-21 9t-21-9L181-536q-9-9-8.5-21t9.5-21q9-9 21-9t21 9l156 156ZM230-160q-13 0-21.5-8.5T200-190q0-13 8.5-21.5T230-220h500q13 0 21.5 8.5T760-190q0 13-8.5 21.5T730-160H230Z"
		/>
	</svg>
);
